import React from 'react';

interface SpinnerProps {
  fullPage?: boolean;
}

export default function Spinner({ fullPage = false }: SpinnerProps) {
  if (!fullPage) return <span className="loader" />;

  return (
    <div className="flex flex-column flex-center w-100 h-100">
      <span className="loader" />
    </div>
  );
}
